import ApexChart, { Props as ApexChartProps } from "react-apexcharts";

type Props = {
  categories: string[];
  data: number[];
};

const BarChart = ({ categories, data }: Props) => {
  const series: ApexChartProps["series"] = [{ name: "瀏覽數", data }];

  const options: ApexChartProps["options"] = {
    chart: {
      type: "bar",
      height: 360,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
    },
    fill: {
      colors: ["#15aabf"],
    },
  };

  return (
    <ApexChart options={options} series={series} type="bar" height={360} />
  );
};

export default BarChart;
